module.exports = ".selectType .form-check:nth-child(1) .cross_icon,\r\n.selectType .form-check:nth-child(2) .cross_icon,\r\n.selectType .form-check:nth-child(3) .cross_icon,\r\n.selectType .form-check:nth-child(4) .cross_icon {\r\n  display: none\r\n}\r\n\r\n.pritingColHead span,\r\n.pritingColHead .info_ico {\r\n  display: inline-block;\r\n  line-height: 1;\r\n}\r\n\r\n.pritingColHead .info_ico {\r\n  margin-left: 5px;\r\n}\r\n\r\n.pritingColHead .info_ico img {\r\n  display: block;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/printing/printing.component.css
// module id = ./src/app/printing/printing.component.css
// module chunks = main